export default {

  name: "searchQueryPerformance",

  requiredFields: ['Query'],

  numericFields: ['Clicks', 'Impressions', 'Cost', 'Conversions', 'ConversionValue'],

  languages: [
    {
      lang: 'pl',
      columnTranslation: {
        'Kliknięcia' : 'Clicks',
        'Wyświetlenia' : 'Impressions',
        'Koszt' : 'Cost',
        'Konwersje' : 'Conversions',
        'Wartość wszystkich konw.' : 'ConversionValue',


        'Kampania' : 'CampaignName',
        'Grupa reklam' : 'AdGroupName',
        'Wyszukiwane hasło' : 'Query'
      },
      summaryRegex: [/^Łącznie/i, /^Razem/i]
    },
    {
      lang: 'en',
      columnTranslation: {
        'Clicks' : 'Clicks',
        'Impressions' : 'Impressions',
        'Cost' : 'Cost',
        'Conversions' : 'Conversions',
        'All conv. value': 'ConversionValue',

        'Campaign' : 'CampaignName',
        'Ad group' : 'AdGroupName',
        'Search term' : 'Query'
      },
      summaryRegex: [/^Total/i]
    }
  ]

}



// WEBPACK FOOTER //
// ./src/config/input/searchQueryPerformance.js